import { Recommended } from 'app/blocks/homepage/recommended'
import React, { useCallback } from 'react'
import Section from 'app/components/structure/Section'
import { ContentCardBookmarkable } from 'app/components/content/ContentCard/ContentCardBookmarkable'
import { ContentCarousel } from 'app/components/content/ContentCarousel'
import { ContentCardProps } from 'app/components/content/ContentCard'
import { useCarouselController } from 'app/hooks/use-carousel-controller'
import { useWatchLaterContext } from 'app/providers/WatchLaterProvider'
import { XStack, YStack } from '@mythical/ui'
import {
  IconChevronLeft,
  IconChevronRight,
} from 'app/components/primitive/Icon'
import { Button } from 'app/components/primitive/Button'

export const RecommendedBlock: React.FC<{ block: Recommended }> = ({
  block,
}) => {
  const { title, content = [] } = block || {}
  const controller = useCarouselController()
  const { isInWatchLater, toggleWatchLater } = useWatchLaterContext()

  const keyExtractor = useCallback((item: ContentCardProps) => item.id, [])
  const renderItem = useCallback(
    (item: ContentCardProps) => (
      <ContentCardBookmarkable
        {...item}
        isInWatchLater={isInWatchLater(item.id)}
        onToggleWatchLater={toggleWatchLater}
      />
    ),
    [isInWatchLater, toggleWatchLater],
  )

  if (!content || content?.length === 0) {
    return null
  }

  return (
    <Section
      paddedX
      title={title || "We think you'll like"}
      $gtSm={{ overflow: 'hidden' }}
      titleHighlight={block.collection.title}
      customCta={
        <XStack gap="$2" $sm={{ dsp: 'none' }}>
          <Button
            theme="white"
            onPress={controller.scrollToPrevious}
            disabled={!controller.canScrollPrevious}
            aria-label="Previous"
            icon={<IconChevronLeft size={16}  />}
            size="$3.5"
            circular
          />
          <Button
            theme="white"
            onPress={controller.scrollToNext}
            disabled={!controller.canScrollNext}
            aria-label="Next"
            circular
            size="$3.5"
            icon={<IconChevronRight size={16}  />}
          />
        </XStack>
      }
    >
      <YStack $gtSm={{ overflow: 'hidden' }}>
        <ContentCarousel
          items={content}
          renderItem={renderItem}
          keyExtractor={keyExtractor}
          controllerRef={controller.carouselRef}
        />
      </YStack>
    </Section>
  )
}
